import { Link } from 'react-router-dom';

const faqs = [
  {
    q: 'What is a Basetao spreadsheet?',
    a: 'A Basetao spreadsheet is a curated database of product finds organized by categories such as Shoes, Hoodies, T-Shirts, Jackets, and more. It provides direct links to Basetao product pages, making it easier to discover and compare items without manually searching the platform.',
  },
  {
    q: 'Is Basetao legit and safe to use?',
    a: 'Yes, Basetao is a legitimate Chinese shopping agent that has been operating for years with thousands of active users worldwide. They offer secure payment options, quality control photos, and reliable warehouse services. The platform is widely used by global shoppers for purchasing items from Chinese marketplaces.',
  },
  {
    q: 'How much does Basetao shipping cost?',
    a: 'Basetao shipping costs vary based on destination country, package weight, dimensions, and the shipping method you choose. They offer multiple carriers with different speed and price points. You can use their built-in shipping calculator to get an estimate before finalizing your order.',
  },
  {
    q: 'Are there Basetao coupon codes available?',
    a: 'Basetao occasionally offers promotional discounts and coupon codes. Check their official website for the latest deals. Following their social media channels is also a good way to stay informed about current promotions and discount opportunities.',
  },
  {
    q: 'How does the Basetao warehouse work?',
    a: 'When you purchase items through Basetao, they are first delivered to the Basetao warehouse. The warehouse team inspects each item, takes QC (quality control) photos, and stores your items until you are ready to ship them internationally. You can consolidate multiple items into one package to save on shipping costs.',
  },
  {
    q: 'How do I use the Basetao spreadsheet to find products?',
    a: 'Simply browse through our 14 product categories, click on any category that interests you, and you will be directed to the corresponding product listings on the Basetao platform. The spreadsheet format makes it easy to compare products, check prices, and discover new finds across different categories.',
  },
];

export default function FaqSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-xs font-semibold text-accent-600 uppercase tracking-widest mb-3">Got Questions</p>
          <h2 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            Common questions about Basetao spreadsheet, shopping, shipping, and more.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq) => (
            <details
              key={faq.q}
              className="group bg-background-100 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                <span className="text-sm md:text-base font-medium text-foreground-800 pr-4">{faq.q}</span>
                <span className="w-6 h-6 flex-shrink-0 flex items-center justify-center rounded-full bg-background-200 text-foreground-500 group-open:bg-primary-100 group-open:text-primary-600 transition-colors">
                  <i className="ri-add-line text-sm group-open:hidden"></i>
                  <i className="ri-subtract-line text-sm hidden group-open:inline"></i>
                </span>
              </summary>
              <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                {faq.a}
              </div>
            </details>
          ))}
        </div>

        <div className="mt-8 text-center">
          <Link
            to="/article/basetao-spreadsheet-guide"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-arrow-right-line"></i>
            Read the complete Basetao spreadsheet guide for more detailed answers
          </Link>
        </div>
      </div>
    </section>
  );
}